/* eslint-disable react/prop-types */
import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import '~styles/modules/candidatelist.scss';

const CandidateList = function ({ candidates, images }) {
  const list = candidates.map((candidate) => {
    const imgSrc = getImage(images.find((image) => image.base === candidate.img));
    return (
      <li key={candidate.shortName}>
        <div className="headshot">
          <GatsbyImage image={imgSrc} alt={candidate.shortName} layout="fluid" placeholder="blurred" />
        </div>
        <div className="name miller-n6">{candidate.name}</div>
        <div className="desc bentoncond-n4">{candidate.desc}</div>
      </li>
    );
  });

  return (
    <div className="candidatelist">
      <ul>{list}</ul>
    </div>
  );
};

export default CandidateList;
